import { RootStore } from "./rootStore";
import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { IList } from "../models/listOfValours";

export default class ListOfValoursStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable rejectionConcepts: IList[] = [];

  //lista ciudades
  @observable cities: IList[] = [];
  //lista departamentos
  @observable countrySubentities: IList[] = [];

  @action getCountrySubentities = async () => {
    try {
      const countrySub = await agent.ListOfValours.getCountrySubentities();
      runInAction(() => {
        this.countrySubentities = [];
        for (var key in countrySub) {
          this.countrySubentities.push({
            key: `${key}-countrysubentities}`,
            text: `${countrySub[key]}`,
            value: key,
          });
        }
      });
    } catch (error) {
      console.error("UPS! No se pudo cargar la lista departamentos");
    }
  };

  @action getCities = async (stateCode: string) => {
    try {
      const cities = await agent.ListOfValours.getCities(stateCode);
      runInAction(() => {
        this.cities = [];
        for (var key in cities) {
          this.cities.push({
            key: `${key}-cities}`,
            text: `${cities[key]}`,
            value: key,
          });
        }
      });
    } catch (error) {
      console.error("UPS! No se pudo cargar la lista cities");
    }
  };

  @action getRejectionConcepts = async () => {
    if (this.rejectionConcepts.length < 1) {
      try {
        const rejectionConcepts = await agent.ListOfValours.getRejectionConcepts();
        runInAction(() => {
          for (var key in rejectionConcepts) {
            this.rejectionConcepts.push({
              key: `${key}-rejectionConcepts}`,
              text: `${rejectionConcepts[key]}`,
              value: key,
            });
          }
        });
      } catch (error) {
        console.error("UPS! No se pudo cargar la lista rejectionConcepts");
      }
    }
  };
}
